import React from 'react';
import './ReportGrid.css';

const ReportGrid = ({ reports, onSelectReport, selectedReport }) => {
  // Function to get report image in cycling order
  const getReportImage = (reportIndex) => {
    // Cycle through images 1-8, then restart
    const imageNumber = (reportIndex % 8) + 1;
    return `/assets/old/report_${imageNumber}.png`;
  };

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return 'No date';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  // Function to truncate text
  const truncateText = (text, maxLength = 100) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <div className="report-grid-container">
      <h2>Reports</h2>
      <div className="reports-grid">
        {reports.map((report, index) => (
          <div
            key={report.id}
            className={`report-card ${selectedReport?.id === report.id ? 'selected' : ''}`}
            onClick={() => onSelectReport(report)}
          >
            <div className="report-card-image">
              <img 
                src={getReportImage(index)} 
                alt={report.title}
                onError={(e) => {
                  // Fallback to a default image if the specific one doesn't exist
                  e.target.src = '/assets/old/report_1.png';
                }}
              />
            </div>
            <div className="report-card-content">
              <div className="report-date">{formatDate(report.date)}</div>
              <h3 className="report-title">{report.title}</h3>
              <p className="report-description">
                {truncateText(report.intro || 'No intro available')}
              </p>
              {selectedReport?.id === report.id && (
                <div className="selected-indicator">✓</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportGrid;
